import { Outlet } from "react-router-dom"
import { Box } from "@mui/material"

const Settings = () => {
  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Outlet />
    </Box>
  )
}

export default Settings

